<span *ngIf="displayTimer" class="gtgt-timer">
	<span class="gtgt-timer-countdown" [ngStyle]="{'color': textColor }">
		<span *ngIf="timer.days > 0">{{ timer.days | number: '2.0-0' }}days:</span>
		<span *ngIf="timer.days > 0 || timer.hours > 0">{{ timer.hours | number: '2.0-0' }}hr:</span>
		<span>{{ timer.minutes | number: '2.0-0' }}min:{{ timer.seconds | number: '2.0-0' }}s<!--econds --></span>
	</span>
</span>
